<template>
  <v-container xv-if='LOGGED_IN && false' id="page" class="xfill-height">

    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"/>
    </v-overlay>

    <v-row v-if="!loading && false">

      <v-col class="col-lg-3 col-md-4 col-sm-6">
        <v-card class="mx-auto fill-height d-flex flex-column rounded-xl">
          <v-img class="align-end text-white flex-grow-0 mx-14" height="200" :src="labImage" contain>
          </v-img>
          <v-card-title>{{ labAccount.business }}</v-card-title>
          <v-card-text>
            Contact us if you have any questions or would like assistance.
          </v-card-text>
          <v-card-actions class="mt-auto">
            <router-link to="./orders"><v-btn rounded text color="primary" class="">Contact</v-btn></router-link>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col class="col-lg-3 col-md-4 col-sm-6">
        <v-card class="mx-auto fill-height d-flex flex-column rounded-xl">
          <v-img class="align-end text-white flex-grow-0" height="200" :src="assets.img_work" cover>
          </v-img>
          <v-card-title>My Orders</v-card-title>
          <v-card-text>
            Stay in the loop as we we manufacture your orders.
          </v-card-text>
          <v-card-actions class="mt-auto">
            <router-link to="./orders"><v-btn rounded text color="primary" class="">View Orders</v-btn></router-link>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col class="col-lg-3 col-md-4 col-sm-6">
        <v-card class="mx-auto fill-height d-flex flex-column rounded-xl">
          <v-img class="align-end text-white flex-grow-0" height="200" :src="assets.img_download" cover>
          </v-img>
          <v-card-title>LaserCAM Software</v-card-title>
          <v-card-text>
            Download our software to prescribe, design, and manufacture custom orthotic devices.
          </v-card-text>
          <v-card-actions class="mt-auto">
            <v-btn rounded text color="primary" class="">Download</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col class="col-lg-3 col-md-4 col-sm-6">
        <v-card class="mx-auto fill-height d-flex flex-column rounded-xl">
          <v-img class="align-end text-white flex-grow-0" height="200" :src="assets.img_book" cover>
          </v-img>
          <v-card-title>Prescription Guides</v-card-title>
          <v-card-text>
            See our guide for details on all prescription options that are available within LaserCAM Prescribe, and more.
          </v-card-text>
          <v-card-actions class="mt-auto">
            <a href="https://lasercamkb.atlassian.net/wiki/spaces/LOK/pages/688249/Machined+EVA" target="_blank">
              <v-btn rounded text color="primary" class="">Open Guide</v-btn>
            </a>
          </v-card-actions>
        </v-card>
      </v-col>

    </v-row>

    <v-row class="">
      <v-col>

        <v-card class="rounded-lg mx-auto" style="max-width:600px;">
          <v-list>

            <v-list-item>
              <v-list-item-content>
                  <v-img class="align-end text-white flex-grow-0 mx-auto my-6" style="max-width:400px;" :src="labImage" contain />
              </v-list-item-content>
            </v-list-item>

            <v-divider />
            
            <template v-if="labAccount?.contact_email">
              <v-list-item :href="`mailto:${labAccount.contact_email}`">
                <v-list-item-icon class="primary pa-3 rounded-lg grad-45">
                  <v-icon color="white" large>mdi-email</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-h6">Email {{ labAccount.business }}</v-list-item-title>
                  <v-list-item-subtitle>{{labAccount.contact_email}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider />
            </template>

            <template v-if="labAccount?.contact_phone">
              <v-list-item :href="`tel:${labAccount.contact_phone}`">
                <v-list-item-icon class="primary pa-3 rounded-lg grad-45">
                  <v-icon color="white" large>mdi-phone</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-h6">Call {{ labAccount.business }}</v-list-item-title>
                  <v-list-item-subtitle>{{labAccount.contact_phone}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider />
            </template> 

            <v-list-item to="./orders">
              <v-list-item-icon class="primary pa-3 rounded-lg grad-45">
                <v-icon color="white" large>mdi-briefcase</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="text-h6">My Orders</v-list-item-title>
                <v-list-item-subtitle>Track the progress of your orders.</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider />

            <template v-if="lasercam_setup_url">
              <v-list-item :href="lasercam_setup_url" three-line>
                <v-list-item-icon class="primary pa-3 rounded-lg grad-45">
                  <v-icon color="white" large>mdi-download</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-h6">Download Software</v-list-item-title>
                  <v-list-item-subtitle>Install the LaserCAM software for Windows PC.</v-list-item-subtitle>
                  <v-list-item-subtitle class="text-subtitle-2">
                    <a href="https://lasercamkb.atlassian.net/wiki/spaces/LOK/pages/163053575/SOP+Lab+Configuration#Update-LaserCAM-Lab-Code" target="_blank">Prescribe Labcode: {{ labAccount.labdata?.labcode }}</a>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider />
            </template>

            <v-list-item href="https://lasercamkb.atlassian.net/wiki/spaces/LOK/pages/688249/Machined+EVA" target="_blank">
              <v-list-item-icon class="primary pa-3 rounded-lg grad-45">
                <v-icon color="white" large>mdi-book-open-variant</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="text-h6">Prescription Guides</v-list-item-title>
                <v-list-item-subtitle>See our detailed guide for all prescription options available.</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

          </v-list>
 
        </v-card>

      </v-col>

    </v-row>

  </v-container>
</template>

<style lang="scss" scoped>
#page{
  .v-skeleton-loader__image{ height: 200px; }
}

.grad-h{ background: linear-gradient(90deg, #FFF1 15%, #0002 85%); }
.grad-45{ background: linear-gradient(135deg, #FFF1 15%, #0002 85%); }
.grad-v{ background: linear-gradient(180deg, #FFF1 15%, #0002 85%); }

</style>


<script>
import { mapActions, mapGetters } from 'vuex'
import img_work from './assets/Work.webp'
import img_download from './assets/Download.webp'
import img_book from './assets/Book.webp'
export default {
  name: 'customer-home',

  components: {
  },

  data: () => ({
    assets: { img_work, img_download, img_book },
    loading: false,
    labAccount: null,
    labImage: null,
    lasercam_setup_url: null,
  }),
  computed: {
    ...mapGetters('Auth', ['LOGGED_IN']),

  },
  methods: {
    ...mapActions('Auth', ['REQUIRE_LOGIN']),
    ...mapActions('UI', ['SET_PAGE_TITLE', 'SHOW_NAVBARS']),
    ...mapActions('API', ['API']),

    refresh(){
      this.loading = true;
      this.API({ method: 'GET', endpoint: 'customer_portal/home' })
      .then(data => {
        this.labAccount = data.account;
        this.labImage = data.logo || `https://placehold.co/600/FFF/00AD79?text=${data.account?.business}`;
        this.lasercam_setup_url = data.lasercam_setup_url;
      })
      .finally(() => { this.loading = false; });
    },

  },
  mounted() {
    this.REQUIRE_LOGIN(()=>{
      this.SHOW_NAVBARS();
      this.SET_PAGE_TITLE('Home');
      this.refresh();
      //this.$vuetify.theme.themes.light.primary = "#FF00FF";
    });
  }
};
</script>
7